<template>
  <div class="main">
    <section class="panel panel-default" style="margin-bottom: 0px;">
      <header class="panel-heading" style="padding: 10px;">
        <div class="panel-actions" style="top: 7px;">
          <a href="#patrolSearchArea" data-toggle="collapse" class="panel-action panel-action-toggle"></a>
        </div>
        <h4 class="panel-title">查詢條件</h4>
      </header>
      <div id="patrolSearchArea" class="panel-collapse collapse in">
        <div class="panel-body">
          <div class="row form-group">
            <div class="col-md-4">
              <label class="col-md-4">學期</label>
              <div class="col-md-8">
                <select v-model="qryParam.smtr" class="form-control">
                  <option value="">--請選擇--</option>
                  <option v-for="(item, index) in selectYear()" :key="index" :value="item.value">{{ item.text }}</option>
                </select>
              </div>
            </div>
            <div class="col-md-4">
              <label class="col-md-4">巡查日期</label>
              <div class="col-md-8">
                <datepicker
                  :format="customFormatter"
                  :language="zh"
                  v-model="qryParam.patrolDate"
                  input-class="form-control topIndex"
                  :style="{ width: 'auto', display: 'inline-block' }"
                />
              </div>
            </div>
            <div class="col-md-4 text-right">
              <div class="col-xs-5 col-md-4 col-md-offset-2">
                <button type="button" class="btn btn-default btn-block" @click="clearSearch">清空</button>
              </div>
              <div class="col-xs-5 col-md-4 col-xs-offset-2 col-md-offset-2">
                <button type="button" class="btn btn-danger btn-block" @click="updateGrid(1)">查詢</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="panel">
      <header class="panel-heading">
        <h2 class="panel-title">宿舍巡查</h2>
      </header>
      <div class="panel-body container-fluid">
        <div class="row form-group">
          <div class="col-md-12 text-right">
            <button type="button" class="btn btn-default hidden-xs" @click="showSignOffExportDialog">列印巡查簽核單</button>
            <button type="button" class="btn btn-default hidden-xs" @click="showRecordExportDialog">匯出巡查紀錄</button>
            <button type="button" class="btn btn-default hidden-xs" @click="showWorkLogExportDialog">匯出學生宿舍管理工作日誌</button>
            <button type="button" class="btn btn-danger hidden-xs" @click="goCreate">新增</button>

            <button type="button" class="btn btn-default btn-block visible-xs" style="margin-bottom: 8px;" @click="showSignOffExportDialog">列印巡查簽核單</button>
            <button type="button" class="btn btn-default btn-block visible-xs" style="margin-bottom: 8px;" @click="showRecordExportDialog">匯出巡查紀錄</button>
            <button type="button" class="btn btn-default btn-block visible-xs" style="margin-bottom: 8px;" @click="showWorkLogExportDialog">匯出學生宿舍管理工作日誌</button>
            <button type="button" class="btn btn-danger btn-block visible-xs" @click="goCreate">新增</button>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <table class="table table-no-more table-bordered table-striped mb-none">
              <thead>
                <tr>
                  <th class="text-center" width="8%">勾選</th>
                  <th class="text-center" width="12%">學期</th>
                  <th class="text-center" width="16%">巡查日期</th>
                  <th class="text-center">巡查紀錄</th>
                  <th class="text-center" width="16%">系統紀錄日期</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="!patrolList.length">
                  <td class="text-center" colspan="5">查無資料</td>
                </tr>
                <tr v-for="(item, index) in patrolList" :key="index">
                  <td class="text-center" data-title="勾選">
                    <input type="checkbox" :value="item.id" v-model="selectedIds" />
                  </td>
                  <td class="text-center" data-title="學期">{{ item.smtr }}</td>
                  <td class="text-center" data-title="巡查日期">{{ item.patrolDateStr }}</td>
                  <td class="text-center" data-title="巡查紀錄">
                    <a href="javascript:;" class="btn btn-link" @click="goEdit(item)">巡查紀錄</a>
                  </td>
                  <td class="text-center" data-title="系統紀錄日期">{{ item.crDateStr }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-md-12">
            <div class="text-center">
              <pageControl :page="page" :total="totalPage"></pageControl>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
/* global bootbox */

export default {
  data() {
    return {
      patrolList: [],
      selectedIds: [],
      page: 1,
      pageSize: 10,
      totalPage: 0,
      qryParam: {
        smtr: "",
        patrolDate: null,
      },
    };
  },
  methods: {
    guardAccess() {
      if (this.isAdmin("stay")) {
        return true;
      }
      bootbox.alert("無宿舍巡查權限", () => {
        this.$router.replace({ name: "stay.list" });
      });
      return false;
    },
    selectYear() {
      let smtrArray = [];
      let nowYear = new Date().getFullYear() - 1911;
      let nowMonth = new Date().getMonth() + 1;
      if (nowMonth < 8) {
        nowYear = nowYear - 1;
      }
      for (let y = nowYear; y > 100; y--) {
        if ((y === nowYear && nowMonth < 8) || y < nowYear) {
          smtrArray.push({ text: y + "年第二學期", value: y + "2" });
        }
        smtrArray.push({ text: y + "年第一學期", value: y + "1" });
      }
      return smtrArray;
    },
    restoreSearch() {
      const storeQryParam = JSON.parse(this.getStore(this.$route.name + ".qryParam"));
      if (storeQryParam) {
        this.qryParam.smtr = storeQryParam.smtr || "";
        this.qryParam.patrolDate = storeQryParam.patrolDate ? new Date(storeQryParam.patrolDate) : null;
        this.page = storeQryParam.page || 1;
        return;
      }

      const years = this.selectYear();
      if (years.length > 0) {
        this.qryParam.smtr = years[0].value;
      }
    },
    buildSearchRequest() {
      return {
        page: this.page,
        pageSize: this.pageSize,
        model: {
          smtr: this.qryParam.smtr,
          patrolDate: this.qryParam.patrolDate ? this.customFormatter(this.qryParam.patrolDate, "YYYY-MM-DD") + "T00:00:00" : null,
        },
      };
    },
    updateGrid(page) {
      this.page = page;
      this.getGridData();
    },
    getGridData() {
      this.setStore(this.$route.name + ".qryParam", {
        smtr: this.qryParam.smtr,
        patrolDate: this.qryParam.patrolDate,
        page: this.page,
      });

      const api = "/api/DormitoryPatrol/grid";
      this.$axios.post(api, JSON.stringify(this.buildSearchRequest())).then((resp) => {
        if (resp.data.status !== "success") {
          bootbox.alert(resp.data.msg || "取得宿舍巡查清單失敗");
          return;
        }
        this.patrolList = resp.data.data.rows || [];
        this.totalPage = resp.data.data.total || 0;
        this.page = resp.data.data.page || this.page;
        this.selectedIds = [];
      });
    },
    clearSearch() {
      this.qryParam.smtr = "";
      this.qryParam.patrolDate = null;
      this.selectedIds = [];
    },
    showSignOffExportDialog() {
      this.showMonthExportDialog("選擇簽核單年月", (monthValue) => this.exportSignOff(monthValue));
    },
    showWorkLogExportDialog() {
      this.showMonthExportDialog("選擇工作日誌年月", (monthValue) => this.exportWorkLog(monthValue));
    },
    showRecordExportDialog() {
      if (!this.selectedIds.length) {
        bootbox.alert("請勾選巡查資料");
        return;
      }

      this.exportRecord(this.selectedIds.slice());
    },
    showMonthExportDialog(title, onConfirm) {
      const defaultMonth = this.customFormatter(new Date(), "YYYY-MM");
      bootbox.dialog({
        title,
        message: `
          <div class="form-group" style="margin-bottom: 0; text-align: left;">
            <label for="patrolExportMonth">年月</label>
            <input id="patrolExportMonth" type="month" class="form-control" value="${defaultMonth}" />
          </div>
        `,
        buttons: {
          cancel: {
            label: "取消",
            className: "btn-default",
          },
          confirm: {
            label: "確定",
            className: "btn-danger",
            callback: () => {
              const monthInput = document.getElementById("patrolExportMonth");
              const monthValue = monthInput ? monthInput.value : "";
              if (!monthValue) {
                bootbox.alert("請選擇匯出年月");
                return false;
              }
              onConfirm(monthValue);
              return true;
            },
          },
        },
      });
    },
    parseMonthExportValue(monthValue) {
      const [year, month] = (monthValue || "").split("-").map((item) => Number(item));
      if (!year || !month) {
        return null;
      }
      return { year, month };
    },
    async exportSignOff(monthValue) {
      const exportMonth = this.parseMonthExportValue(monthValue);
      if (!exportMonth) {
        bootbox.alert("匯出年月格式錯誤");
        return;
      }

      try {
        const resp = await this.$axios.post(
          "/api/DormitoryPatrol/export-sign-off",
          JSON.stringify(exportMonth),
          { responseType: "blob" }
        );
        await this.downloadBlobResponse(resp, "宿舍巡查簽核單.docx");
      } catch (error) {
        await this.handleBlobRequestError(error, "匯出巡查簽核單失敗");
      }
    },
    async exportWorkLog(monthValue) {
      const exportMonth = this.parseMonthExportValue(monthValue);
      if (!exportMonth) {
        bootbox.alert("匯出年月格式錯誤");
        return;
      }

      try {
        const resp = await this.$axios.post(
          "/api/DormitoryPatrol/export-work-log",
          JSON.stringify(exportMonth),
          { responseType: "blob" }
        );
        await this.downloadBlobResponse(resp, "學生宿舍管理工作日誌.xlsx");
      } catch (error) {
        await this.handleBlobRequestError(error, "匯出學生宿舍管理工作日誌失敗");
      }
    },
    async exportRecord(ids) {
      if (!ids || !ids.length) {
        bootbox.alert("請勾選巡查資料");
        return;
      }

      try {
        const resp = await this.$axios.post(
          "/api/DormitoryPatrol/export-record",
          JSON.stringify({ ids }),
          { responseType: "blob" }
        );
        await this.downloadBlobResponse(resp, "宿舍巡查紀錄_匯出.docx");
      } catch (error) {
        await this.handleBlobRequestError(error, "匯出巡查紀錄失敗");
      }
    },
    getResponseHeader(resp, headerName) {
      if (!resp || !resp.headers) {
        return "";
      }
      return resp.headers[headerName] || resp.headers[headerName.toLowerCase()] || "";
    },
    isBlobErrorResponse(resp) {
      const contentType = this.getResponseHeader(resp, "content-type");
      return (
        contentType.includes("application/json") ||
        contentType.includes("application/problem") ||
        contentType.includes("text/plain")
      );
    },
    readBlobAsText(blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(typeof reader.result === "string" ? reader.result : "");
        reader.onerror = () => reject(reader.error);
        reader.readAsText(blob);
      });
    },
    async parseBlobJson(blob) {
      try {
        const text = await this.readBlobAsText(blob);
        return text ? JSON.parse(text) : null;
      } catch (error) {
        return null;
      }
    },
    async getBlobErrorMessage(blob, fallbackMessage) {
      try {
        const json = await this.parseBlobJson(blob);
        if (json && json.msg) {
          return json.msg;
        }

        const text = await this.readBlobAsText(blob);
        return text || fallbackMessage;
      } catch (error) {
        return fallbackMessage;
      }
    },
    extractFileNameFromDisposition(disposition) {
      if (!disposition) {
        return "";
      }

      const utfMatch = disposition.match(/filename\*=UTF-8''([^;]+)/i);
      if (utfMatch && utfMatch[1]) {
        return decodeURIComponent(utfMatch[1]);
      }

      const normalMatch = disposition.match(/filename="?([^";]+)"?/i);
      return normalMatch && normalMatch[1] ? decodeURIComponent(normalMatch[1]) : "";
    },
    async downloadBlobResponse(resp, fallbackName) {
      if (this.isBlobErrorResponse(resp)) {
        const message = await this.getBlobErrorMessage(resp.data, "匯出失敗");
        bootbox.alert(message || "匯出失敗");
        return;
      }

      const contentType = this.getResponseHeader(resp, "content-type") || "application/octet-stream";
      const disposition = this.getResponseHeader(resp, "content-disposition");
      const fileName = this.extractFileNameFromDisposition(disposition) || fallbackName;
      const blob = resp.data instanceof Blob
        ? resp.data
        : new Blob([resp.data], { type: contentType });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    },
    async handleBlobRequestError(error, fallbackMessage) {
      if (error && error.response && error.response.data) {
        const message = await this.getBlobErrorMessage(error.response.data, fallbackMessage);
        bootbox.alert(message || fallbackMessage);
        return;
      }

      bootbox.alert(fallbackMessage);
    },
    goCreate() {
      this.removeStore("stay.patrol.edit");
      this.$router.push({ name: "stay.patrol.edit" });
    },
    goEdit(item) {
      this.setStore("stay.patrol.edit", { id: item.id });
      this.$router.push({ name: "stay.patrol.edit", query: { id: item.id } });
    },
  },
  mounted() {
    if (!this.guardAccess()) {
      return;
    }
    this.restoreSearch();
    this.getGridData();
  },
};
</script>